import { Button, Flex, useTheme } from '@chakra-ui/react';
import { lighten } from '../../utils/functions';

interface IOwnProps {
  mainButtonText: string;
  onGoMainButton?(): void;
  goBackButtonText?: string;
  onGoBackButton?(): void;
  mainButtonDisabled?: boolean;
  isLoading?: boolean;
  loadingText?: string;
  w?: string;
  absolute?: boolean;
  typeButton?: 'submit' | 'button';
  formId?: string;
}

const NavigationButtonMobilePage: React.FC<IOwnProps> = ({
  goBackButtonText,
  mainButtonText,
  mainButtonDisabled,
  onGoBackButton,
  onGoMainButton,
  isLoading,
  loadingText,
  absolute,
  typeButton,
  formId,
  w = '30%',
}) => {
  const theme = useTheme();

  const primaryColor = theme.semanticTokens.colors.primaryColor;

  return (
    <Flex
      gap={3}
      borderTopWidth="1px"
      bgColor="white"
      boxShadow="0px 0px 10px #7272725b"
      justifyContent="center"
      py={2}
      px={!onGoBackButton ? '20%' : 0}
      w="full"
      position={absolute ? 'fixed' : 'initial'}
      bottom={absolute ? 0 : 'initial'}
      left={absolute ? 0 : 'initial'}
    >
      {onGoBackButton && (
        <Button
          borderColor="primaryColor"
          minW="fit-content"
          w={w}
          borderWidth="1px"
          variant="ghost"
          onClick={onGoBackButton}
          _hover={{ background: 'white' }}
          _active={{ background: 'gray.200' }}
        >
          {goBackButtonText || 'Cancelar'}
        </Button>
      )}
      <Button
        bgColor="primaryColor"
        onClick={typeButton ? undefined : onGoMainButton}
        _hover={{ background: 'primaryColor' }}
        _active={{ background: lighten(primaryColor, 80) }}
        form={formId}
        isLoading={isLoading}
        loadingText={loadingText}
        isDisabled={mainButtonDisabled}
        color="white"
        minW="fit-content"
        w={w}
        type={typeButton}
      >
        {mainButtonText}
      </Button>
    </Flex>
  );
};

export default NavigationButtonMobilePage;
